import Control from './Control';
import House_1 from './House-1';
import House_2 from './House-2';
import Init from './Init';
import Town from './Town';

export default [Init, Town, House_1, House_2, Control];
